import { EntityWidget } from "./EntityWidget";
import { StaircaseEntityController } from "../StaircaseEntityController";
import { SceneConstants, Staircase } from "@rhinov/savane-js";

export class StaircaseEntityWidget extends EntityWidget{

    declare controller: StaircaseEntityController;
    declare entity: Staircase;

    handleImageListEvent = (event: MouseEvent) => {
        var elem =  event.currentTarget as HTMLButtonElement & { param?: any };
        if (event.ctrlKey) {
            this.controller.openAssetDetail(elem.param);
            return;
        }
        if (!event.ctrlKey && event.button === 0) {
           
            var index = 0;
            this.controller.allModelsForCurrentTechnicalElement.forEach((modele: any) => {
                let element = document.getElementById(`TechnicalElementModel-${index}`);
                if (element) {
                    element.classList.remove('active');
                }
                index++;
            })
            elem.classList.add('active');
            this.controller.updateTechnicalElementModeleType(elem.param);
            let preview = document.getElementById('previewTechElem')
            if (preview && preview.getElementsByTagName("img")[0]) {
                preview.getElementsByTagName("img")[0].src = this.controller.itemPreview ?? '';
            }
        }
    }

    constructor(entity: Staircase, panel: any, deliverable: any, openAssetDetailCallback: CallableFunction) {
        super(entity, panel, deliverable, openAssetDetailCallback);
        this.controller = new StaircaseEntityController(entity,panel, deliverable, openAssetDetailCallback);
        switch (this.entity.objectId) {
            case SceneConstants.StaircaseType.straight:
                this.propertiesTab = ['dropDown', 'plusLess', 'plusLess', 'plusLess', 'plusLess', 'plusLess', 'buttonToggle', 'buttonToggle', 'styleStaircase', 'buttonToggle',
                    'buttonToggle', 'dropDown', 'plusLess', 'dropDown', 'dropDown', 'plusLess', 'plusLess', 'plusLess', 'previewStair', 'previewTechnicalElement', 'selectTechnicalElementModel']
                break;
            case SceneConstants.StaircaseType.quarterTurn:
            case SceneConstants.StaircaseType.doubleQuarterTurn:
                this.propertiesTab = ['dropDown', 'plusLess', 'plusLess', 'plusLess', 'plusLess', 'plusLess', 'buttonToggle', 'buttonToggle', 'styleStaircase', 'buttonToggle',
                    'buttonToggle', 'dropDown', 'plusLess', 'buttonToggle', 'dropDown', 'dropDown', 'plusLess', 'plusLess', 'plusLess', 'previewStair', 'previewTechnicalElement', 'selectTechnicalElementModel']
                break;
            case SceneConstants.StaircaseType.circular:
                this.propertiesTab = ['dropDown', 'plusLess', 'plusLess', 'plusLess', 'plusLess', 'buttonToggle', 'buttonToggle', 'styleStaircase', 'buttonToggle',
                    'buttonToggle', 'dropDown', 'plusLess', 'dropDown', 'dropDown', 'plusLess', 'plusLess', 'plusLess', 'previewTechnicalElement', 'selectTechnicalElementModel']
                break;
        }
        this.controller.propertiesTab = this.propertiesTab;
    }

    handleElementList(): string {
        var html = "";
        var index = 0;
        this.controller.allModelsForCurrentTechnicalElement.forEach((modele: any) => {
            html += `
                <img id="TechnicalElementModel-${index}" style="display: inline-block;width:180px;height:180px;vertical-align:text-bottom"
                    title="${modele.name}"
                    src="${this.controller.getTechnicalElementPreviewUrl(modele)}"
                    class="${this.controller.isTechnicalElementModelSelected(modele) ? "active" : ""}"></li>
            `;
            index++;
        })
        return html;
    }

    selectTechnicalElementModel(property: any): string {
        return `
            <!--Select model for technical elements-->
            <div class="property-item padding tulipImage">
                <h style="font-weight:600;">
                    ${property.title}
                </h>
                <div style="margin-bottom:10px;padding:0;width:382px;max-height:650px;overflow-y:auto">
                    ${this.handleElementList()}
                </div>
            </div>
        `;
    }

    setselectTechnicalElementModelListener() {
        var index = 0;
        this.controller.allModelsForCurrentTechnicalElement.forEach((modele: any) => {
            let element = document.getElementById(`TechnicalElementModel-${index}`) as HTMLButtonElement & { param?: any };;
            if (element) {
                element.param = modele;
                element.addEventListener('mousedown', this.handleImageListEvent);
            }
            index++;
        })
    }

    removeselectTechnicalElementModelListener() {
        var index = 0;
        this.controller.allModelsForCurrentTechnicalElement.forEach((modele: any) => {
            let element = document.getElementById(`TechnicalElementModel-${index}`);
            if (element) {
                element.removeEventListener('mousedown', this.handleImageListEvent);
            }
            index++;
        })
    }
    
    previewTechnicalElement(property: any): string {
        return `
            <!-- PREVIEW -->
            <div id="previewTechElem" class="property-item padding tulipImage">
                <h  style="font-weight:600;">
                    ${property.title}
                </h>
                <div>
                    <img style="width:180px;height:180px;" src="${this.controller.itemPreview}" />
                </div>
            </div>
        `;
    }

    setpreviewTechnicalElementListener() {
        let preview = document.getElementById('previewTechElem');
        if (preview) {
            preview.addEventListener('mousedown', this.previewDetails)
        }
    }

    removepreviewTechnicalElementListener() {
        let preview = document.getElementById('previewTechElem');
        if (preview) {
            preview.removeEventListener('mousedown', this.previewDetails)
        }
    }

    previewStair(property: any): string {
        return `
            <!-- PREVIEW -->
            <div class="property-item padding tulipImage">
                <h style="font-weight:600;">
                    ${property.title}
                </h>
                <div>
                    <img id="previewStair" style="width:180px;height:180px;" src="${this.controller.itemStairPreview}}" />
                </div>
            </div>
        `;
    }

    html(): string {
        var i;
        var html = super.nameHeader() + super.propertyStart();
        for (i = 0; i < this.propertiesTab.length; i++) {
            if ((this as any)[this.propertiesTab[i]] !== undefined) {
                html += (this as any)[this.propertiesTab[i]](this.panel.properties[i]);
            }
        }
        html += super.propertyEnd();
        return html;
    }
}